import React from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../../../hooks/useDialogState";
import { useTreeState } from "../../../../../hooks/useTreeState";
import { useAttributeState } from "../../../../../hooks/useAttributeState";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Alert from "@mui/material/Alert";
import TreeComponentTypeService from "../../../../../services/TreeComponentTypeService";
import {trackPromise} from "react-promise-tracker";

import {useStylesDialog} from "../../../../../shared/useStyleDialog";

// Fenster zum Löschen des ausgewählten Attributes

// Transition legt fest, wie das Fenster erscheint
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});


export default function DeleteAttrDialog({reloadTreeItem}) {

  const classesDialog = useStylesDialog();
  const dialog = useDialogState();
  const tree = useTreeState();
  const attribute = useAttributeState();
  const token = useSelector((state) => state.keycloakToken);
  const realm = useSelector((state) => state.theRealm);
  const DeleteAttrDialogOpen = dialog.deleteAttrOpen;
  const setDeleteAttrDialogOpen = dialog.setDeleteAttrOpen;
  const TreeSelected = tree.selected;
  const setTreeSelected = tree.setSelected;
  const AttrSelected = attribute.selected;

  const Attr_Delete = async () => {
    try {
      await trackPromise((async () => {
        await TreeComponentTypeService.deleteComponentTypeAttribute(token, realm, AttrSelected.global_id);
        const result = await TreeComponentTypeService.getTreeData(token, realm);
        tree.setItems(result.data);
        attribute.setIsSelected(false);

        const newItem = await reloadTreeItem();
        if (newItem instanceof Array && newItem.length > 0) {
          setTreeSelected(newItem[0]);
        }
      })());
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog
      className={classesDialog.dialog50}
      open={DeleteAttrDialogOpen}
      onClose={() => setDeleteAttrDialogOpen(false)}
      TransitionComponent={Transition}
    >
      <AppBar className={classesDialog.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setDeleteAttrDialogOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classesDialog.title}>
            Merkmal <b>{AttrSelected.name}</b> löschen
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Alert variant="outlined" severity="error">
          <DialogContentText id="alert-dialog-slide-description">
            <b>Möchten Sie das Merkmal{" "}
            <div className={classesDialog.highlight}>{AttrSelected.name}</div> des
            Bauteiles{" "}
            <div className={classesDialog.highlight}>{TreeSelected.name}</div>{" "}
            wirklich löschen?</b>
          </DialogContentText>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeleteAttrDialogOpen(false);
          }}
          color="primary"
        >
          Abbrechen
        </Button>
        <Button
          onClick={async () => {
            await Attr_Delete();
            setDeleteAttrDialogOpen(false);
          }}
          color="primary"
        >
          Bestätigen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
